import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { initObservability } from "./lib/observability";
import "./theme.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "./index.css";

// ADV-1223: start browser RUM before React renders so the Dash0 fetch
// instrumentation patches window.fetch ahead of the first request.
initObservability();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
